export const NOTIFICATION_EVENTS = {
    CLOSE: 'CLOSE',
    ALERT: 'ALERT',
    PROMPT: 'PROMPT',
    PROMPT_WITH_CONFIRM: 'PROMPT_WITH_CONFIRM',
    CONFIRM: 'CONFIRM',
    CONFIRM_WITHOUT_CLOSE: 'CONFIRM_WITHOUT_CLOSE',
    INFO: 'INFO',
    POSITIVE: 'POSITIVE',
    REMOVE_ALL: 'REMOVE_ALL',
    OPENED: 'OPENED',
    CLOSED: 'CLOSED',
}
